"use client";

import React from "react";
import { cn } from "@/lib/utils";

export interface LayoutShellProps {
  title: string;
  subtitle?: string;
  headerRight?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export function LayoutShell({
  title,
  subtitle,
  headerRight,
  children,
  className,
}: LayoutShellProps) {
  return (
    <div className={cn(
      "min-h-screen w-full",
      "bg-gradient-to-br from-slate-950 via-purple-950/20 to-slate-900",
      "relative overflow-hidden",
      className
    )}>
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, rgba(255,255,255,0.15) 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }} />
      </div>

      {/* Content */}
      <div className="relative z-10">
        {/* Header */}
        <div className="border-b border-white/10 bg-white/5 backdrop-blur-sm">
          <div className="container mx-auto px-6 py-6">
            <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
              <div>
                <h1 className="text-3xl font-bold text-white tracking-tight">
                  {title}
                </h1>
                {subtitle && (
                  <p className="mt-2 text-sm text-white/70">
                    {subtitle}
                  </p>
                )}
              </div>
              {headerRight && (
                <div className="flex items-center gap-3">
                  {headerRight}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Main content */}
        <div className="container mx-auto px-6 py-8">
          {children}
        </div>
      </div>
    </div>
  );
}

